import { BookingDisplayModeEnum } from './types';

export const getClassNames = (mode: BookingDisplayModeEnum, isValidated?: boolean) => {
  if (mode === BookingDisplayModeEnum.Compact) {
    return `h-full flex-col ${typeof isValidated === 'boolean' ? 'py-0 pl-0 pr-1' : 'p-1'}`;
  }
  if (mode === BookingDisplayModeEnum.Regular) {
    return `h-10 ${typeof isValidated === 'boolean' ? 'py-0 px-0 pr-2' : 'py-0 px-2'} items-center`;
  }
  if (mode === BookingDisplayModeEnum.NoPadding) {
    return 'h-full flex-col';
  }
  if (mode === BookingDisplayModeEnum.Block) {
    return `h-full py-px ${typeof isValidated === 'boolean' ? 'pl-0 pr-1' : 'px-1'}`;
  }
  if (mode === BookingDisplayModeEnum.Mini) {
    return 'h-5 px-0.5 items-center rounded-md!';
  }
  if (mode === BookingDisplayModeEnum.Stacked) {
    return `min-h-10 py-1 ${typeof isValidated === 'boolean' ? 'pl-0 pr-2' : 'px-2'} items-center`;
  }
  return '';
};
